export default class ListFilterType {
  constructor() {
    this.list = []
  }

  getList() {
    return this.list
  }

  getOption(value) {
    return this.list.find(option => option.value === value)
  }
}
